import React from "react";
import "../styles/PopUpStyles.css"; // Import styles
import warningImg from "../assets/images/warningimg.png";
import infoImg from "../assets/images/infoImg.png";
import crossImg from "../assets/images/errorImg.png";
import successImg from "../assets/images/successImg.png";
import closeIcon from "../assets/images/crossCloseicon.png";

interface PopupProps {
  title: string;
  body: string;
  btn1onPressed?: () => void;
  btn2onPressed?: () => void;
}

const QuizPopUpLogout: React.FC<PopupProps> = ({
  title,
  body,
  btn1onPressed,
  btn2onPressed,
}) => {
  const popupConfig = {
    warning: {
      icon: warningImg,
      titleColor: "#4b4c4e",
      borderColor: "#7B101C",
      btnColor: "#000000",
    },
    confirmation: {
      icon: infoImg,
           titleColor: "#4b4c4e",
      borderColor: "#A78903",
            btnColor: "#000000",
    },
    error: {
      icon: crossImg,
      titleColor: "#4b4c4e",
      borderColor: "#D43345",
            btnColor: "#000000",

    },
    logout: {
      icon: successImg,
      titleColor: "#4b4c4e",
      borderColor: "#02cc8c",
            btnColor: "#000000",

    },
  };

  const currentConfig =
    popupConfig[title.toLowerCase() as keyof typeof popupConfig] ||
    popupConfig.logout;

  return (
   <div className="popupQuiz-overlay">
  <div className="popupQuizLogout-container">

    {/* Header */}
    <div
      className="popupQuiz-header"
      style={{ backgroundColor: currentConfig.borderColor }}
    >
      <img
        src={closeIcon}
        alt="close"
        className="popupQuiz-close-icon"
        onClick={btn2onPressed}
      />
    </div>

    {/* Icon */}
    <img
      src={currentConfig.icon}
      alt="popup-icon"
      className="popupQuiz-top-icon"
    />
<br></br><br></br>
    <h2
      className="popupQuiz-title"
      style={{ color: currentConfig.titleColor }}
    >
      {title}
    </h2>

    <p className="popupQuiz-message">{body}</p>

    <div className="popupQuiz-footer">
      <button
        onClick={btn1onPressed}
        className="popupQuiz-btn"
        style={{
          border: `1px solid ${currentConfig.borderColor}`,
          color: currentConfig.btnColor || currentConfig.borderColor,
        }}
      >
        Okay
      </button>

      <button
        onClick={btn2onPressed}
        className="popupQuiz-btn"
        style={{
          border: `1px solid ${currentConfig.borderColor}`,
          color: currentConfig.btnColor || currentConfig.borderColor,
        }}
      >
        Cancel
      </button>
    </div>
  </div>
</div>
  );
};

export default QuizPopUpLogout;
export const CopyRightPopup: React.FC<PopupProps> = ({
  title,
  body,
  btn1onPressed,
}) => {
  return (
    <div className="popupQuiz-overlay">
      <div className="popupQuizLogout-container-copyRight">
        <div className="popupQuizLogout-header">
          <h3>{title}</h3>
        </div>
        <div className="popupQuizLogout-body-copyRight">
          <p
            style={{
              fontSize: "16px",
              color: "#2d2d2d",
              fontFamily: "Mazzard",
            }}
          >
            {body}
          </p>
        </div>
        <div className="popupQuiz-footer">
          <button
            onClick={btn1onPressed}
            className="popupQuizLogout-buttons-copyRight"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};
